import { DirectiveBase } from '../angular-directive-base.directive';

export class NavButton extends DirectiveBase {
  constructor() {
    super();
    this.restrict = 'E';
    this.scope = {
      buttonText: '@',
      onClickCallback: '&'
    };
    this.template = '<md-button ng-click="onClickCallback()"><md-icon class="material-icons">keyboard_arrow_left</md-icon><span translate>{{buttonText}}</span></md-button>';
  }
}